module.exports = __webpack_public_path__ + "static/sport/swiper-4.a61cc44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jump/swiper/swiper-4.jpg
// module id = s7oN
// module chunks = 0